import React from 'react';
import SoftSkillPill from '../../Utils/SoftSkillPill';

const SoftSkills = ({ softSkills }) => {
  return (
    <div className="bg-white rounded-lg shadow" style={{ overflow: 'visible', borderRadius: '0.5rem' }}>
      <div className="px-6 py-4">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Soft Skills</h3>
        {softSkills?.items && 
         (Array.isArray(softSkills.items) ? 
          softSkills.items.length > 0 : true) ? (
          Array.isArray(softSkills.items) ? (
            <div className="flex flex-wrap gap-2">
              {softSkills.items.map((skill, index) => (
                <SoftSkillPill
                  key={index}
                  name={skill.skill}
                  title={skill.rationale || "No rationale provided"}
                  context={skill.context}
                />
              ))}
            </div>
          ) : (
            <SoftSkillPill
              name={softSkills.items.skill}
              title={softSkills.items.rationale || "No rationale provided"}
              context={softSkills.items.context}
            />
          )
        ) : (
          <div className="py-8 text-center">
            <p className="text-gray-500 italic">The candidate has not listed any soft skills.</p>
            <p className="text-gray-400 text-sm mt-2">Soft skills will appear here when available.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default SoftSkills;
